module.exports = __webpack_public_path__ + "img/customerImg.cc14b7d7.png";